export const createFunSub = (data:any) =>{
  return (data && data!== null) ? data.map((d:any)=> { return {idFuncion:d.idFuncion, funcion:d.funcion, idSubFuncion: d.idSubFuncion, subFuncion: d.subFuncion} }) :[];
}